// @flow
import * as React from 'react';
import Hero from 'components/Hero';
import { H1, H2 } from 'components/Text';
import Flex from 'components/Flex';
import Box from 'components/Box';
import type { GradCtaHeroBlockData } from 'api/cms';
import { CallToActionButton } from 'components/Button';
import { trackClicked } from 'utils/analytics';

const GradCallToActionHeroBlock = ({
  data: { text, image },
  loggedIn,
  hasGradProgram,
  isPageHeader,
  parallax,
  blockIndex,
  pageUpdated
}: {
  data: GradCtaHeroBlockData,
  loggedIn: boolean,
  hasGradProgram: boolean,
  isPageHeader?: boolean,
  parallax?: boolean,
  blockIndex: number,
  pageUpdated: string
}) => {
  const Heading = isPageHeader ? H1 : H2;
  return (
    <Hero
      withOverlay
      heroImage={image}
      data-qa-id="grad-call-to-action-hero"
      parallax={parallax}
      minHeight="calc(100vh - 300px)"
    >
      <Box maxWidth="768px" m="0 auto" px="20px">
        <Heading
          mt={['48px', '48px', '48px', '80px']}
          mb={['18px', '18px', '18px', '42px']}
          color="white"
          textAlign="center"
        >
          {text}
        </Heading>
      </Box>
      <Flex>
        <CallToActionButton
          loggedIn={loggedIn}
          hasGradProgram={hasGradProgram}
          size="large"
          data-qa-id="grad-cta-button"
          onClick={() => {
            trackClicked('CMS Block', {
              block_position: blockIndex,
              block_type: 'Grad Call to Action Hero',
              cta_type: 'Button',
              page_updated: pageUpdated
            });
          }}
        />
      </Flex>
    </Hero>
  );
};

export default GradCallToActionHeroBlock;
